<script setup>
  import { Plus } from "lucide-vue-next";
  import { ref } from "vue";
  import { storeToRefs } from "pinia";
  import { Button } from "@/components/ui/button";
  import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";
  import { useMMediumUploadsStore } from "@stores/mMediumUploads";
  import ImageLibraryModal from "@/components/MCampaign/ImageLibrary/ImageLibraryModal.vue";

  const isOpen = ref(true);

  const mMediumUploadsStore = useMMediumUploadsStore();
  const { images, activeImages } = storeToRefs(mMediumUploadsStore);
  const { toggleMMediumUpload, isMMediumUploadSelected, toggleModalLibrary } = mMediumUploadsStore;
</script>

<template>
  <div>
    <Collapsible
      :open="isOpen"
      @update:open="isOpen = $event">
      <CollapsibleTrigger class="flex w-full items-center justify-between py-2 text-sm font-medium">
        Assets
      </CollapsibleTrigger>
      <CollapsibleContent>
        <div class="mb-2">
          <Button
            size="sm"
            @click="toggleModalLibrary()">
            <Plus class="h-4 w-4 mr-1" />
            Edit Assets
          </Button>
        </div>
        <ul class="flex flex-wrap list-none p-0 m-0">
          <li
            v-for="(mMedium, index) in images"
            :key="`creative-asset-${index}`"
            class="mr-2 mb-2 inline-flex h-[136px] w-[136px] cursor-pointer overflow-hidden rounded-md border-2 bg-muted"
            :class="isMMediumUploadSelected(mMedium.id) ? 'border-primary' : 'border-border'"
            @click="toggleMMediumUpload(mMedium)">
            <img
              class="block h-full w-full max-w-full object-contain"
              :src="mMedium.url"
              :alt="mMedium.name" />
          </li>
        </ul>
      </CollapsibleContent>
    </Collapsible>

    <div v-if="!isOpen">
      <ul class="inline-flex flex-wrap gap-0 list-none p-0 m-0">
        <li
          v-for="(mMedium, index) in activeImages"
          :key="`creative-asset-${index}`"
          class="mr-2 mb-2 inline-flex h-[136px] w-[136px] overflow-hidden rounded-md border-2 border-primary bg-muted">
          <img
            class="block h-full w-full max-w-full object-contain"
            :src="mMedium.url"
            :alt="mMedium.name" />
        </li>
      </ul>
    </div>
  </div>
  <ImageLibraryModal />
</template>
